import React from 'react';

type InviteActionModalHeaderProps = {
  title: string;
  subtitle: string;
  titleEndIcon?: JSX.Element;
};
function InviteActionModalHeader({
  title,
  subtitle,
  titleEndIcon
}: InviteActionModalHeaderProps) {
  return (
    <div>
      <h2 className="flex text-lg text-gray-900 font-semibold justify-center leading-6 mb-4">
        {title}
        {titleEndIcon ? (
          <>
            <span>&nbsp;</span>
            {titleEndIcon}
          </>
        ) : null}
      </h2>
      <p className="flex leading-6 justify-center mb-10 px-10 font-medium text-sm">
        {subtitle}
      </p>
    </div>
  );
}

export default InviteActionModalHeader;
